import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Page from '../../components/Page';
import BranchDashboard from '../../containers/BranchDashboard';
import CompanyDashboard from './../../containers/CompanyDashboard';
import UserDashboard from './../../containers/UserDashboard';
import Header from '../../containers/Header';
import MessageDisplay from '../../containers/MessageDisplay';
import OverviewDashboard from '../../containers/OverviewDashboard';

const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: 85
  }
}));

const AdminPage = (props) => {
  const { visibleTab, loggedInUser } = props;
  const classes = useStyles();

  let unavailable = false;

  let dashboard;
  switch (visibleTab) {
    case 0:
      dashboard = <CompanyDashboard />;
      break;
    case 1:
      dashboard = <BranchDashboard />;
      break;
    case 2:
      dashboard = <UserDashboard />;
      break;
    case 3:
      dashboard = <OverviewDashboard />;
      unavailable =
        loggedInUser.companyId == null || loggedInUser.companyId === 0;
      break;
    default:
  }

  return (
    <React.Fragment>
      <MessageDisplay />

      <div className="App">
        <header>
          <Header />
        </header>
        <Page>
          <div className={classes.content}>
            {unavailable ? (
              <h2 className={classes.noPermissionHeader}>
                This page is unavailable for your login
              </h2>
            ) : (
              dashboard
            )}
          </div>
        </Page>
      </div>
    </React.Fragment>
  );
};

export default AdminPage;
